<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div class="project-container" v-for="(projects, index) in stations" :key="index">
      <div class="station-row" v-for="(station, index) in projects" :key="index">
        <h4 v-if="index===0">{{ station.project.project_name }} 
            <router-link class="link back-page" :to="station.report_url" target="_blank"><sc-button variant="primary"
          >ดูรายงานการใช้</sc-button></router-link></h4>
        <el-row>
          <el-col :span="6"><div class="grid-content">{{ station.name }}</div></el-col>
          <el-col :span="18">
            <div class="grid-content" v-if="station.current_session === null">ว่าง</div>
            <div class="grid-content" v-if="station.current_session !== null">
              <el-col :span="5">
                <el-row class="grid-current-session">เลขทะเบียนรถ</el-row>
                <el-row>{{ station.current_session.car_license }}</el-row>
              </el-col>
              <el-col :span="5">
                <el-row class="grid-current-session">รุ่นรถ</el-row>
                <el-row>{{ station.current_session.car_name }}</el-row>
              </el-col>
              <el-col :span="5">
                <el-row class="grid-current-session">เวลาเข้า</el-row>
                <el-row>{{ station.current_session.started_at | moment-datetime }}</el-row>
              </el-col>
              <el-col :span="5">
                <el-row class="grid-current-session">ปริมาณไฟ</el-row>
                <el-row>{{ station.current_session.total_kwh }}/{{ station.current_session.current_accu_kwh }}</el-row>
              </el-col>
              <el-col :span="4">
                <button class="btn sc-btn sc-btn-opaque"
                  @click="stopButtonHandler(station.current_session.id)"
                  >
                  <span>Stop&Exit</span>
                </button>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../../../lib/components/PageWrapper";
import { Row, Col } from "element-ui";
import { evUseCase } from "../EvUseCase";
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import ScButton from "@/lib/components/ScButton";


export default {
  name: 'EvOverviewPage',
  components: {
    PageWrapper,
    "el-row": Row,
    "el-col": Col,
    ScButton,
  },
  data() {
    const pageWrapper = {
      title: "EV Parking",
      hasPad: true
    };
    const stations = []
    return {
      pageWrapper,
      stations,
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.setupStationData();
    },
    async stopButtonHandler(sessionId) {
      const response = await evUseCase.stopAndExit(sessionId)
      this.setupStationData();
    },
    async setupStationData() {
      const projectWithStations = await evUseCase.getStations();
      this.stations = projectWithStations.map(
        (project) => project.map((station) => {
          return {
            ...station,
            report_url: { name: "EvReportPage", query: { projectId: station.project.project_id } }
          }
      })
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  .station-row {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .project-container{
    margin-bottom: 25px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .grid-current-session {
    border-bottom: 1px solid;
    border-color: #d3dce6;
    margin-right: 5px;
  }
  .grid-content {
    padding: 5px;
    border: 1px solid;
    border-color: #d3dce6;
    min-height: 64px;
  }
</style>


// WEBPACK FOOTER //
// src/features/ev-parking/pages/EvOverviewPage.vue